import { createSlice } from "@reduxjs/toolkit";
import { campDetailsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const campDetailSlice = createSlice({
  name: "campDetail",
  initialState: data,
  reducers: {
    campDetailSlice(state) {
      state.isLoading = true;
    },
    campDetailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    campDetailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    campDetailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const campDetailHandler = (slug:any) => async (dispatch: any) => {
  try {
    dispatch(campDetailAction.campDetailSlice());
    const response: any = await campDetailsAPI(slug);
    dispatch(campDetailAction.campDetailSliceSuccess(response));
      return { status: 200, results: response?.results };
  } catch (e: any) {
    const statusCode = e?.response?.status || 500;
    const errorMessage = e?.response?.data?.error_message || "Something went wrong";
    dispatch(campDetailAction.campDetailSliceFailure(errorMessage));
    dispatch(campDetailAction.campDetailSliceReset());    
    return { status: statusCode, message: errorMessage };
  }
};

export default campDetailSlice.reducer;
export const campDetailAction = campDetailSlice.actions;